
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 12"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Polygon_1","data-name":"Polygon 1","fill":"#6964eb"}},[_c('path',{attrs:{"d":"M13.13 11.5H.87L7 .992 13.13 11.5z"}}),_c('path',{attrs:{"d":"M7 1.985L1.741 11h10.518L7 1.985M7 .492c.168 0 .335.083.432.248l6.13 10.508a.5.5 0 01-.433.752H.871a.5.5 0 01-.432-.752L6.569.74A.495.495 0 017 .492z"}})])])
          )
        }
      }
    